import React from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material/styles";
import Plotting from "./Plotting";

export default function AnalyzeClassification(props) {
    // init internationalization
    const {t} = useTranslation();
    const theme = useTheme();
    const {classNames, confusionMatrixVal, confusionMatrixTrain} = props.runData.predictionDetails;

    return (
        <>
            {classNames && (
                <>
                    <Grid item xl={3} md={12} sm={12}>
                        <TableContainer component={Paper}>
                            <Table aria-label="caption table">
                                <caption>
                                    {t("analyzer.ConfusionMatrixCaption")} <br/>
                                </caption>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">
                                            {t("runs.AccuracyPlotXLabel")}
                                        </TableCell>
                                        <TableCell align="left">
                                            {t("analyzer.AccuracyTableValLabel")}
                                        </TableCell>
                                        <TableCell align="left">
                                            {t("analyzer.AccuracyTableTrainLabel")}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {classNames.map((className, index) => (
                                        <TableRow key={`row-idx-${index}`}>
                                            <TableCell align="left">{className}</TableCell>
                                            <TableCell align="left">
                                                {confusionMatrixVal[index][index]} %
                                            </TableCell>
                                            <TableCell align="left">
                                                {confusionMatrixTrain[index][index]} %
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xl={9} xs={6} sx={{marginTop: theme.spacing(4)}}/>
                    {classNames.length <= 10 && (
                        <>
                            <Grid item xl={12} md={12} sm={12}>
                                <Grid container spacing={2} row-spacing={6}>
                                    <Grid item xl={8} md={12} sm={12}>
                                        <Card>
                                            <Plotting runData={props.runData} type="confusionMatrixVal"/>
                                        </Card>
                                    </Grid>
                                    <Grid item xl={4} md={12} sm={12}>
                                        <Card sx={{backgroundColor: theme.palette.background.default}}>
                                            <CardContent>
                                                <Typography gutterBottom variant="h5" component="div">
                                                    {t("analyzer.ConfusionMatrixDescriptionTitle")}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {t("analyzer.ConfusionMatrixDescriptionBody")}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item xl={8} md={12} sm={12}>
                                        <Card>
                                            <Plotting runData={props.runData} type="confusionMatrixTrain"/>
                                        </Card>
                                    </Grid>
                                    <Grid item xs={4}/>
                                </Grid>
                                <Grid container spacing={2} row-spacing={6}>
                                {Object.keys(props.runData.featureImportance).length && (
                                    <>
                                        <Grid item lg={8} xs={12}>
                                            <Card>
                                                <Plotting runData={props.runData} type="featureImportance"/>
                                            </Card>
                                        </Grid>
                                        <Grid item lg={4} xs={12}>
                                            <Card sx={{backgroundColor: theme.palette.background.default}}>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="div">
                                                        Feature Importance Plot
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {t("analyzer.DescriptionFeatureImportance")}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </>
                                )}
                                <Grid item lg={8} xs={12}>
                                    <Card>
                                        <Typography gutterBottom variant="h6"
                                                    sx={{
                                                        textAlign: "center",
                                                        marginTop: "25px",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        color: theme.palette.secondary.dark,
                                                    }}>
                                            {t("analyzer.LabelSHAPPlot")}
                                        </Typography>
                                        <img
                                            alt="SHAP Plot"
                                            width={600}
                                            src={`data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(props.runData.SHAPBeeswarmPlot[0])))}`}
                                            style={{margin: "20px"}}
                                        />
                                    </Card>
                                    </Grid>
                                    <Grid item lg={3} xs={12}>
                                        <Card sx={{backgroundColor: theme.palette.background.default}}>
                                            <CardContent>
                                                <Typography gutterBottom variant="h5" component="div">
                                                    SHAP Plot
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {t("analyzer.DescriptionSHAP")}
                                                </Typography>
                                                <br/>
                                                <a href="https://github.com/shap/shap/tree/master" rel="noreferrer"
                                                   target="_blank">🔗 {t("common.LearnMoreButton")}</a>
                                                <br/>
                                                <a href="https://www.aidancooper.co.uk/content/images/size/w1600/2021/11/beeswarm-1.png?xgtab&"
                                                   rel="noreferrer"
                                                   target="_blank">🔗 {t("analyzer.ReadMoreSHAPExplanation")}</a>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    )}

                </>
            )}
        </>
    )
}







